// extracted by mini-css-extract-plugin
module.exports = {"liveTag":"styles_liveTag__3zbC0","liveAnimation":"styles_liveAnimation__n3jWy"};